module.exports = __webpack_public_path__ + "img/zil.86c3735c.svg";